import CoverLetterPage from "../features/cover-letter/CoverLetterPage";

export default function CoverLetterRoute() {
  return <CoverLetterPage />;
}
